import React from 'react'
//import I18n from "i18n-js/index.js.erb"

class ApplyToAllButton extends React.Component {
  
  constructor(props) {
    super(props)
  }
  
  render() {
    return (
      <div className="apply-to-all-button"> 
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <a className="primary"  style={{cursor: "pointer"}} onClick={e => this.props.onChangeAllDays(this.props.sundayAmount, this.props.roomTypeId)}>{I18n.t('apply_sunday_price')}</a>    
            </div>
          </div>
        </div>
    
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <a className="primary" style={{cursor: "pointer"}} onClick={e => this.props.onChangeAllMinimumStays(this.props.sundayMinimumStay, this.props.roomTypeId)}>{I18n.t('apply_sunday_minimum')}</a>  
            </div>
          </div>
        </div> 
      </div>
    );
  };  
   
};

export default ApplyToAllButton